module.exports = __webpack_public_path__ + "static/media/DocumentIcon.1eed9744.svg";